import {URL_POST_VENTA} from "../../../api/config";
import makeQuery from "../../../api/helper";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    notas_credito: [],
    notas_credito_caja: [],
    desde: "",
    hasta: "",
    creacion: ""
  },
  mutations: {
    "SET_NOTAS_CREDITO"(state, payload) {
      state.notas_credito = payload
    },
    "SET_NOTAS_CREDITO_CAJA"(state, payload) {
      state.notas_credito_caja = payload
    }
  },
  actions: {
    async getNotasCredito({commit}) {
      try {
        const {data} = await this._vm.$axios.get(URL_POST_VENTA)
        commit("SET_NOTAS_CREDITO", data.items)
      } catch (e) {
        console.log(e)
      }
    },

    async getNotasCreditoCaja({commit, state, dispatch}, payload) {
      try {
        const query = await dispatch("createQuery", payload)
        const {data} = await this._vm.$axios.get(URL_POST_VENTA + query)
        commit("SET_NOTAS_CREDITO_CAJA", data.items.sort((a, b) => a.folio_dcto_devolucion - b.folio_dcto_devolucion))
      } catch (e) {
        console.log(e)
      }
    },

    createQuery(context, payload = {}) {
      const apertura = moment(payload.apertura).format('YYYY-MM-DD THH:mm:ss')
      const cierre =
        moment(payload.cierre)
          .format('DD-MM-YYYY HH:mm:ss') === 'Invalid date' ?
          moment()
            .format('YYYY-MM-DD THH:mm:ss') :
          moment(payload.cierre)
            .format('YYYY-MM-DD THH:mm:ss')

      return makeQuery({
        filtros: [
          {field: "createdAt", value: apertura, operator: ">="},
          {field: "createdAt", value: cierre, operator: "<="},
          {field: "sucursal_nombre", value: payload.sucursal, operator: "="},
        ]
      })
    }
  },
  getters: {
    notas_credito: state => state.notas_credito,
    notas_credito_caja: state => state.notas_credito_caja,
  }
}
